import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-warningpopup',
  templateUrl: './warningpopup.component.html',
  styleUrls: ['./warningpopup.component.css']
})

export class WarningpopupComponent implements OnInit {
  warnmsgcontact: any; warnAlertmsgcontact: any;
  @Output() CloseonNo = new EventEmitter();
  @Output() CloseonYes = new EventEmitter(); 
  @Input() set warningmsgcontact(warningmsgcontact: any) { this.warnmsgcontact = warningmsgcontact; }
  @Input() set warningAlertmsgcontact(warningAlertmsgcontact: any) { this.warnAlertmsgcontact = warningAlertmsgcontact; }
  @Input() set flagForline2(flagForline2: any) { this._flagForline2 = flagForline2; }

  public _flagForline2: boolean = true;
  constructor() { }

  ngOnInit() {
    this.setDefault();   
  }

  setDefault() {
    if (this.warnAlertmsgcontact == "") {
      this.warnAlertmsgcontact = "Are you sure you want to leave?";
    }
  }

  closeno() {
    this.CloseonNo.emit();
  }

  closeyes() {
    this.CloseonYes.emit();
    this.warnAlertmsgcontact = "";
  }
}
